import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_LTC_DETAILS: "applications/FETCH_LTC_DETAILS",
  SAVE_LTC_DETAILS: "applications/SAVE_LTC_DETAILS",
};

const initialState = {
  loading: false,
  ltcDetails: null,
};

export type ApplicationLtcState = Readonly<typeof initialState>;

/**
 * ApplicationLtc Reducer
 */
export default (state: ApplicationLtcState = initialState, action): ApplicationLtcState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_LTC_DETAILS):
    case PENDING(ACTION_TYPES.SAVE_LTC_DETAILS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_LTC_DETAILS):
      return { ...state, loading: false, ltcDetails: action.payload.data };

    case FULFILLED(ACTION_TYPES.SAVE_LTC_DETAILS):
      return { ...state, loading: false };

    case REJECTED(ACTION_TYPES.FETCH_LTC_DETAILS):

    case REJECTED(ACTION_TYPES.SAVE_LTC_DETAILS):
      return { ...state, loading: false };

    default:
      return state;
  }
};

/**
 * Actions for fetching LTC data
 */

export const fetchLtcDetails = (applicationId: string) => ({
  type: ACTION_TYPES.FETCH_LTC_DETAILS,
  meta: { applicationId },
  payload: axios.get(`/applications/${applicationId}/ltcDetails`),
});

/**
 * Action to save or update LTC details
 */
export const saveLtcDetails = (applicationId, ltcData) => ({
  type: ACTION_TYPES.SAVE_LTC_DETAILS,
  payload: axios.post(`/applications/${applicationId}/ltcDetails`, ltcData, {
    headers: { "Content-Type": "application/json" },
  }),
});
